// Generated by cmms-connectors/scripts/export_document_contract.py; values are presentation labels only.
import { i18n, type MessageDescriptor } from '@lingui/core'
import { msg } from '@lingui/core/macro'

const labels: Record<string, MessageDescriptor> = {
  'Actual date': msg`Actual date`,
  'Actual finish': msg`Actual finish`,
  'Actual labor cost': msg`Actual labor cost`,
  'Actual labor hours': msg`Actual labor hours`,
  'Actual material cost': msg`Actual material cost`,
  'Actual service cost': msg`Actual service cost`,
  'Actual start': msg`Actual start`,
  'Actual tool cost': msg`Actual tool cost`,
  Ancestor: msg`Ancestor`,
  Asset: msg`Asset`,
  'Asset meter': msg`Asset meter`,
  'Asset register': msg`Asset register`,
  'Asset specification': msg`Asset specification`,
  'Asset type': msg`Asset type`,
  'Assigned owner group': msg`Assigned owner group`,
  Attribute: msg`Attribute`,
  Author: msg`Author`,
  'Available balance field': msg`Available balance field`,
  'Average cost': msg`Average cost`,
  Bin: msg`Bin`,
  'Bin balance': msg`Bin balance`,
  'Bin-level stock snapshot; not a reservation or availability guarantee.': msg`Bin-level stock snapshot; not a reservation or availability guarantee.`,
  'Catalog code': msg`Catalog code`,
  'Catalog item': msg`Catalog item`,
  'Catalog specifications; not proof of installation.': msg`Catalog specifications; not proof of installation.`,
  Category: msg`Category`,
  City: msg`City`,
  'Cost distribution': msg`Cost distribution`,
  Country: msg`Country`,
  Craft: msg`Craft`,
  Created: msg`Created`,
  'Crew work group': msg`Crew work group`,
  Currency: msg`Currency`,
  'Current balance': msg`Current balance`,
  Description: msg`Description`,
  'Description and task text describe scope; status alone does not verify performed work.': msg`Description and task text describe scope; status alone does not verify performed work.`,
  'Description detail': msg`Description detail`,
  Detail: msg`Detail`,
  'Direct-issue material availability': msg`Direct-issue material availability`,
  'Drawing reference': msg`Drawing reference`,
  'Equipment identity and recorded configuration.': msg`Equipment identity and recorded configuration.`,
  'Estimate at approval: labor cost': msg`Estimate at approval: labor cost`,
  'Estimate at approval: labor hours': msg`Estimate at approval: labor hours`,
  'Estimate at approval: material cost': msg`Estimate at approval: material cost`,
  'Estimate at approval: service cost': msg`Estimate at approval: service cost`,
  'Estimate at approval: tool cost': msg`Estimate at approval: tool cost`,
  'Estimated duration (hours)': msg`Estimated duration (hours)`,
  'Estimated labor cost': msg`Estimated labor cost`,
  'Estimated labor hours': msg`Estimated labor hours`,
  'Estimated material cost': msg`Estimated material cost`,
  'Estimated service cost': msg`Estimated service cost`,
  'Estimated tool cost': msg`Estimated tool cost`,
  Frequency: msg`Frequency`,
  'Frequency unit': msg`Frequency unit`,
  'From bin': msg`From bin`,
  'From storeroom': msg`From storeroom`,
  'Inspection asset': msg`Inspection asset`,
  'Inspection field': msg`Inspection field`,
  'Inspection form': msg`Inspection form`,
  'Inspection question number': msg`Inspection question number`,
  'Inspection response': msg`Inspection response`,
  'Inspection result': msg`Inspection result`,
  'Inventory balance': msg`Inventory balance`,
  'Inventory stock': msg`Inventory stock`,
  'Inventory usage': msg`Inventory usage`,
  'Inventory valuation': msg`Inventory valuation`,
  'Issue unit': msg`Issue unit`,
  'Issued quantity': msg`Issued quantity`,
  Item: msg`Item`,
  'Item set': msg`Item set`,
  'Item type': msg`Item type`,
  'Job plan': msg`Job plan`,
  'Job task': msg`Job task`,
  'Job-plan revision': msg`Job-plan revision`,
  Labor: msg`Labor`,
  'Last cost': msg`Last cost`,
  'Last recorded completion date': msg`Last recorded completion date`,
  Lead: msg`Lead`,
  'Line cost': msg`Line cost`,
  'Line cost in transaction currency': msg`Line cost in transaction currency`,
  'Line number': msg`Line number`,
  'Line type': msg`Line type`,
  Location: msg`Location`,
  'Location ancestor': msg`Location ancestor`,
  'Location hierarchy': msg`Location hierarchy`,
  'Location meter': msg`Location meter`,
  'Location specification': msg`Location specification`,
  'Location system': msg`Location system`,
  'Location type': msg`Location type`,
  'Log type': msg`Log type`,
  Manufacturer: msg`Manufacturer`,
  'Material availability updated': msg`Material availability updated`,
  'Material usage line': msg`Material usage line`,
  Materials: msg`Materials`,
  'Maximo organization': msg`Maximo organization`,
  'Maximo site': msg`Maximo site`,
  'Maximum level': msg`Maximum level`,
  Meter: msg`Meter`,
  'Minimum level': msg`Minimum level`,
  Model: msg`Model`,
  Name: msg`Name`,
  'Next PM due': msg`Next PM due`,
  'Next scheduled date': msg`Next scheduled date`,
  'Numeric response': msg`Numeric response`,
  'Numeric value': msg`Numeric value`,
  'Operating location': msg`Operating location`,
  'Order date': msg`Order date`,
  'Order quantity': msg`Order quantity`,
  'Order unit': msg`Order unit`,
  'Ordered line': msg`Ordered line`,
  'Ordered scope; not proof of installation or repair.': msg`Ordered scope; not proof of installation or repair.`,
  'Originating record': msg`Originating record`,
  'Originating record class': msg`Originating record class`,
  Owner: msg`Owner`,
  'Owner group': msg`Owner group`,
  PM: msg`PM`,
  'PM due': msg`PM due`,
  'PM meter': msg`PM meter`,
  'PO reference': msg`PO reference`,
  Parent: msg`Parent`,
  'Parent location': msg`Parent location`,
  'Person group': msg`Person group`,
  'Physical count': msg`Physical count`,
  'Physical count date': msg`Physical count date`,
  'Planned hours': msg`Planned hours`,
  'Planned instructions and resources; not performed work.': msg`Planned instructions and resources; not performed work.`,
  'Planned item': msg`Planned item`,
  'Planned item quantity': msg`Planned item quantity`,
  'Planned job-plan sequence': msg`Planned job-plan sequence`,
  'Planned labor': msg`Planned labor`,
  'Planned material': msg`Planned material`,
  'Planned service': msg`Planned service`,
  'Planned task': msg`Planned task`,
  'Planned tool': msg`Planned tool`,
  Planning: msg`Planning`,
  'Predecessor job plan': msg`Predecessor job plan`,
  'Predecessor task': msg`Predecessor task`,
  'Preventive maintenance schedule': msg`Preventive maintenance schedule`,
  Priority: msg`Priority`,
  'Priority description': msg`Priority description`,
  'Priority justification': msg`Priority justification`,
  'Purchase order': msg`Purchase order`,
  'Purchase requisition': msg`Purchase requisition`,
  'Purchasing term': msg`Purchasing term`,
  Quantity: msg`Quantity`,
  Question: msg`Question`,
  'Receipt state': msg`Receipt state`,
  'Received quantity': msg`Received quantity`,
  'Record class': msg`Record class`,
  'Record details': msg`Record details`,
  'Recorded inspection responses; unanswered fields are not passes.': msg`Recorded inspection responses; unanswered fields are not passes.`,
  'Recorded location and hierarchy.': msg`Recorded location and hierarchy.`,
  'Recorded material movement; not proof of installation.': msg`Recorded material movement; not proof of installation.`,
  'Recorded material transaction': msg`Recorded material transaction`,
  'Recorded receipt transaction': msg`Recorded receipt transaction`,
  'Recorded supplier': msg`Recorded supplier`,
  'Referenced asset': msg`Referenced asset`,
  'Referenced inventory': msg`Referenced inventory`,
  'Referenced job plan': msg`Referenced job plan`,
  'Referenced location': msg`Referenced location`,
  Region: msg`Region`,
  'Rejected quantity': msg`Rejected quantity`,
  Reported: msg`Reported`,
  'Reported by': msg`Reported by`,
  'Requested line': msg`Requested line`,
  'Requested procurement; not proof of ordering or receipt.': msg`Requested procurement; not proof of ordering or receipt.`,
  'Required date': msg`Required date`,
  'Requisition issue date': msg`Requisition issue date`,
  'Requisition term': msg`Requisition term`,
  'Respond by': msg`Respond by`,
  'Response date': msg`Response date`,
  Responsibility: msg`Responsibility`,
  Result: msg`Result`,
  'Result status': msg`Result status`,
  'Returned quantity': msg`Returned quantity`,
  Revision: msg`Revision`,
  Route: msg`Route`,
  'Route stop': msg`Route stop`,
  Schedule: msg`Schedule`,
  'Scheduled finish': msg`Scheduled finish`,
  'Scheduled start': msg`Scheduled start`,
  'Scheduled work; not evidence of execution.': msg`Scheduled work; not evidence of execution.`,
  'Selected inspection option': msg`Selected inspection option`,
  'Selected response': msg`Selected response`,
  Sequence: msg`Sequence`,
  'Serial number': msg`Serial number`,
  Site: msg`Site`,
  Skill: msg`Skill`,
  Source: msg`Source`,
  'Source changed by': msg`Source changed by`,
  Status: msg`Status`,
  'Status label': msg`Status label`,
  'Storeroom material availability': msg`Storeroom material availability`,
  'Storeroom snapshot; not a reservation or availability guarantee.': msg`Storeroom snapshot; not a reservation or availability guarantee.`,
  'Storeroom total balance': msg`Storeroom total balance`,
  Supervisor: msg`Supervisor`,
  'Supplier identity; not proof of equipment compatibility.': msg`Supplier identity; not proof of equipment compatibility.`,
  System: msg`System`,
  'Target finish': msg`Target finish`,
  'Target start': msg`Target start`,
  'Task duration': msg`Task duration`,
  'Task number': msg`Task number`,
  'Task record': msg`Task record`,
  'Task relationship': msg`Task relationship`,
  'Task sequence': msg`Task sequence`,
  Term: msg`Term`,
  'Text response': msg`Text response`,
  Timeline: msg`Timeline`,
  'To bin': msg`To bin`,
  'To storeroom': msg`To storeroom`,
  Tool: msg`Tool`,
  'Total cost': msg`Total cost`,
  Totals: msg`Totals`,
  'Transaction date': msg`Transaction date`,
  'Transaction type': msg`Transaction type`,
  Unit: msg`Unit`,
  'Unit cost': msg`Unit cost`,
  'Unit cost in transaction currency': msg`Unit cost in transaction currency`,
  'Usage split': msg`Usage split`,
  'Use type': msg`Use type`,
  Value: msg`Value`,
  Vendor: msg`Vendor`,
  'Vendor category': msg`Vendor category`,
  'Vendor directory': msg`Vendor directory`,
  'WO group': msg`WO group`,
  'Work log': msg`Work log`,
  'Work order': msg`Work order`,
  'Work order reference': msg`Work order reference`,
  'Work type': msg`Work type`,
  'Work-order priority': msg`Work-order priority`,
  'Work-package material availability': msg`Work-package material availability`,
  naes_confinedspace: msg`naes_confinedspace`,
  naes_crane: msg`naes_crane`,
  naes_environmental: msg`naes_environmental`,
  naes_insulation: msg`naes_insulation`,
  naes_loto: msg`naes_loto`,
  naes_lotoid: msg`naes_lotoid`,
  naes_moc: msg`naes_moc`,
  naes_nde: msg`naes_nde`,
  naes_nerc: msg`naes_nerc`,
  naes_outage: msg`naes_outage`,
  naes_outagedur: msg`naes_outagedur`,
  naes_outagetype: msg`naes_outagetype`,
  naes_outageyear: msg`naes_outageyear`,
  naes_projectid: msg`naes_projectid`,
  naes_pwht: msg`naes_pwht`,
  naes_safety: msg`naes_safety`,
  naes_scaffolding: msg`naes_scaffolding`,
  naes_welding: msg`naes_welding`,
  risk: msg`risk`,
}

export function cmmsDocumentLabel(value: string): string {
  const numbered = /^(.*) (\d+)$/.exec(value)
  const label = numbered?.[1] ?? value
  const message = Object.hasOwn(labels, label) ? labels[label] : undefined
  const translated = message ? i18n._(message) : label
  return numbered ? `${translated} ${numbered[2]}` : translated
}
